import { DropdownItem } from '../../model/dropdown-item.model';

export class TestOption implements DropdownItem {
    myId: string;
    myDescription: string;
    disabled: boolean;
    getId = () => {
        return this.myId;
    }
    getDescription = () => {
        return this.myDescription;
    }
    isDisabled = () => {
        return this.disabled;
    }
    constructor(id: string, description: string) {
        this.myId = id;
        this.myDescription = description;
        this.disabled = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/dropdown/test-option.model.ts